function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["children", "compact", "fullWidth", "rounded", "theme", "uiTheme"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled from 'styled-components';
import { get, reduce } from 'lodash';
import Typography from '../Typography';
import withTheme from '../Theme/withTheme';
import { reduceStyleObjectToCss } from '../../utils/js-style-to-css';
var Button = function Button(_ref) {
  var children = _ref.children,
    compact = _ref.compact,
    fullWidth = _ref.fullWidth,
    rounded = _ref.rounded,
    theme = _ref.theme,
    uiTheme = _ref.uiTheme,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("button", otherProps, /*#__PURE__*/React.createElement(Typography, {
    preset: "button",
    color: "inherit"
  }, children));
};
Button.defaultProps = {
  compact: false,
  disabled: false,
  fullWidth: false,
  rounded: false,
  style: {},
  theme: null,
  type: 'submit',
  uiTheme: null
};
function getTheme(theme, name) {
  return get(theme, "button.themes[".concat(name, "]"), {});
}
function getPreset(theme, name) {
  return get(theme, "button.presets[".concat(name, "]"), {});
}
var StyledButton = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  var compact = props.compact,
    disabled = props.disabled,
    fullWidth = props.fullWidth,
    rounded = props.rounded,
    theme = props.theme,
    uiTheme = props.uiTheme;
  var style = _objectSpread({}, getPreset(uiTheme, 'base'));
  if (theme) style = _objectSpread(_objectSpread({}, style), getTheme(uiTheme, theme));
  if (compact) style = _objectSpread(_objectSpread({}, style), getPreset(uiTheme, 'compact'));
  if (fullWidth) style = _objectSpread(_objectSpread({}, style), getPreset(uiTheme, 'fullWidth'));
  if (disabled) style = _objectSpread(_objectSpread({}, style), getPreset(uiTheme, 'disabled'));
  if (rounded) style = _objectSpread(_objectSpread({}, style), getPreset(uiTheme, 'rounded'));
  return reduce(style, reduceStyleObjectToCss, '');
});
Button.displayName = 'Button';
export default withTheme(StyledButton);